var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container seg-content general user" }, [
      _c(
        "section",
        { staticClass: "home-list" },
        [
          _c(
            "a",
            {
              staticClass: "new-button",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.createNew($event)
                }
              }
            },
            [_vm._v("Add New Type")]
          ),
          _vm._v(" "),
          _vm.selectedItem === null
            ? _c("item-list-types", {
                attrs: { entity: "VideoType" },
                on: {
                  select: function($event) {
                    _vm.selectedItem = $event
                  }
                }
              })
            : _c("item-edit", {
                attrs: { entity: "VideoType", item: _vm.selectedItem },
                on: {
                  save: function($event) {
                    _vm.selectedItem = null
                  }
                }
              })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }